import { get } from 'lodash';
import React, { Component, PropTypes } from 'react';
import { push } from 'react-router-redux';
import { connect } from 'react-redux';
import { updateWorksheet, removeWorksheet } from '../../../redux/actionCreators/sync';

import ModalClose from '../ModalClose';

import * as ui from '../../../redux/actionCreators/sync/ui';


@connect(store => ({ trail: store.worksheets.trail }))
export default class Worksheet extends Component {
  static propTypes = {
    baseRoute : PropTypes.string.isRequired,
    dispatch : PropTypes.func.isRequired,
    location : PropTypes.object.isRequired,
    trail :  PropTypes.array.isRequired,
    pin : PropTypes.object,
    className: PropTypes.string
  }

  constructor(props, context) {
    super(props, context);

    const {
      dispatch,
      baseRoute,
      location,
    } = props;

    this.updateLocation(dispatch, baseRoute, location);
    this.onBack = () => this.respondToKeyPress();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.location !== this.props.location) {
      const {
        dispatch,
        baseRoute,
        location
      } = this.props;

      this.updateLocation(dispatch, baseRoute, location);
    }
  }

  componentDidMount() {
    window.addEventListener('keydown', this.onBack);
  }

  componentWillUnmount() {
    window.removeEventListener('keydown', this.onBack);
  }

  getComponent(key) {
    return this.props.children.filter(c => !!c).filter(c => c.key === key);
  }

  getChildren() {
    return this.props.children.filter(c => !!c).filter(c => !['Card', 'SubNav', 'Side'].includes(c.key));
  }

  goBack = () => {
    const prevWorksheet = this.props.trail.find(p => p.worksheet !== this.props.baseRoute) || {path: this.props.baseRoute};
    this.props.dispatch(ui.showSpinner());
    this.props.dispatch(removeWorksheet(this.props.baseRoute));
    this.props.dispatch(push(prevWorksheet.path));
  }

  updateLocation(dispatch, baseRoute, location) {
    const path = location.pathname.toLowerCase().replace(/\/$/, "");
    dispatch(updateWorksheet(baseRoute, path));
  }

  respondToKeyPress = (event) => {
    // escape key response
    if(event && event.keyCode === 27) {
      return this.goBack();
    }
  }

  render() {
    const CardComponent = this.getComponent('Card');
    const hasCardPanel = !!CardComponent.length;
    const SubNavComponent = this.getComponent('SubNav');
    const hasSubNavPanel = !!SubNavComponent.length;
    const SideComponent = this.getComponent('Side');
    const hasSidePanel = !!SideComponent.length;

    return (
      <div className={`worksheet-component ${get(this.props, 'className', '')}`}>
        <Toolbar
          goBack={this.goBack}
          pin={this.props.pin}
        />
        <div className="worksheet-content">
          <div className="worksheet-content-main">
            {
              hasCardPanel
              &&
              <div className="worksheet-content-card">
              {
                CardComponent
              }
              </div>
            }
            {
              hasSubNavPanel
              &&
              <div className="worksheet-content-subnav">
              {
                SubNavComponent
              }
              </div>
            }
            <div className="worksheet-content-panels">
            {
              this.getChildren()
            }
            </div>
          </div>
          {
            hasSidePanel
            &&
            <div className="worksheet-content-side">
              {
                SideComponent
              }
            </div>
          }
        </div>
      </div>
    );
  }
}

function Toolbar(props) {
  const {
    isPinned = false,
    pin,
    goBack
  } = props;

  return (
    <div className="worksheet-toolbar">
      {
        (pin)
        &&
        <div className="worksheet-toolbar-item left">{pin}</div>
      }
      {
        (goBack)
        &&
        <ModalClose
          handleClose={goBack}
        />
      }
    </div>
  )
}

Toolbar.propTypes = {
  isPinned : PropTypes.bool,  // For future use
  pin : PropTypes.func, // For future use
  goBack : PropTypes.func
};



// WEBPACK FOOTER //
// ./shared/common/components/Worksheet/index.js